import { keyframes } from 'styled-components/macro';
import { styled, css } from '../../../theme';

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const PreviewDialog = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    height: 100%;
    animation: ${slideUp} 260ms cubic-bezier(0.34, 1.4, 0.64, 1);
  `}
`;

export const CarouselArea = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-height: 320px;
    position: relative;
    overflow: hidden;
    cursor: grab;
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;

    &:active {
      cursor: grabbing;
    }

    ${theme.tokens.media.tablet} {
      min-height: 0;
    }
  `}
`;

export const CarouselTrack = styled.div<{ $total: number }>`
  display: flex;
  width: ${({ $total }) => $total * 100}%;
  height: 100%;
  will-change: transform;
`;

export const CarouselSlide = styled.div<{ $bg?: string }>`
  ${({ $bg }) => css`
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    ${$bg &&
    css`
      &::before {
        content: '';
        position: absolute;
        inset: 0;

        background-image: url(${$bg});
        background-size: cover;
        background-position: center;

        filter: blur(10px);
        transform: scale(1.2);

        z-index: 0;
      }
    `}

    & > * {
      position: relative;
      z-index: 1;
    }
  `}
`;

export const CarouselImage = styled.img`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  pointer-events: none;
  -webkit-user-drag: none;
`;

export const SwipablePanel = styled.div`
  ${() => css`
    width: 100%;
    height: 100%;
    will-change: transform, opacity;
  `}
`;

export const StickyContainer = styled.div`
  position: sticky;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
